// extracted by mini-css-extract-plugin
export default {"container":"EmptyView_container__1ynuf","iconContainer":"EmptyView_iconContainer__2QC9m","title":"EmptyView_title__uLgYx","message":"EmptyView_message__1m-VR"};